import styled from '@emotion/styled';
import { theme } from '../../theme';
export const Container = styled.div `
	display: flex;
	align-items: ${(props) => props.stack === 'horizontal' ? 'flex-start' : 'center'};
	justify-content: space-between;

	border-radius: ${(props) => props.stack === 'horizontal'
    ? '14px' // Slightly smaller than radius being used elsewhere to give inner curve effect
    : theme.radii.radii30};
	background-color: ${theme.colors.BB20T};
	max-width: ${(props) => props.stack === 'horizontal' ? '200px' : '100%'};
	padding: ${theme.spacing.space20};
`;
export const Content = styled.div `
	min-width: 0;
	${(props) => props.stack === 'vertical' && `
			display: flex;
			align-items: center;
			flex: 1;
		}
	`};
`;
export const Image = styled.img `
	${(props) => props.stack === 'horizontal' ? `margin-bottom: ${theme.spacing.space20}` : `margin-right: ${theme.spacing.space20}`};
	width: 48px;
	height: 48px;
	border-radius: ${(props) => props.stack === 'horizontal' ? theme.radii.radii30 : theme.radii.radii20};
`;
export const IconContainer = styled.div `
	width: 48px;
	height: 48px;
	border-radius: ${theme.radii.radii30};
	background-color: ${theme.colors.BB20T};
	${(props) => props.stack === 'horizontal' ? `margin-bottom: ${theme.spacing.space20}` : `margin-right: ${theme.spacing.space20}`};
`;
export const MetaInfo = styled.div `
	div:first-of-type {
		margin-bottom: ${theme.spacing.space10};
	}
	${(props) => props.stack === 'vertical' && `
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex: 1;
			min-width: 0;
			div:first-of-type {
				margin-bottom: 0;
				margin-right: ${theme.spacing.space20};
			}
		}
	`};
`;
export const FileName = styled.div `
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	color: ${theme.colors.LM_NU70T};
	font-family: ${theme.typography.IB90.fontFamily};
	font-size: ${theme.typography.IB90.fontSize};
	font-weight: ${theme.typography.IB90.fontWeight};
	line-height: ${theme.typography.lineHeight.sm};
`;
export const FileSize = styled.div `
	white-space: nowrap;
	color: ${theme.colors.LM_NU70T};
	font-family: ${theme.typography.IR80.fontFamily};
	font-size: ${theme.typography.IR80.fontSize};
	font-weight: ${theme.typography.IR80.fontWeight};
	line-height: ${theme.typography.lineHeight.sm};
`;
export const ButtonContainer = styled.div `
	margin: ${(props) => props.stack === 'horizontal'
    ? `-${theme.spacing.space10} -${theme.spacing.space10} 0 ${theme.spacing.space20};`
    : `0 0 0 ${theme.spacing.space20}`};
`;
//# sourceMappingURL=Attachment.styled.js.map